import React, { useState } from "react";
import { Droppable } from "react-beautiful-dnd";
import styled from "styled-components";
import searchObject from "../../../services/searchObject";
import Candidate from "./Candidate";

const Container = styled.div`
  border: 1px solid lightgrey;
  border-radius: 4px;
  margin: 8px;
  /* min-width: 10vw; */
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 10vw;
  border-color: ${(props) => (props.isDragging ? "#4e73df" : "lightgrey")};
  color: ${(props) => (props.isDragging ? "white" : "inherit")};
  background: ${(props) => (props.isDragging ? "#4e73df" : "white")};
  transition: all 0.1s ease-in-out;
`;
const Title = styled.h3`
  padding: 8px;
  font-size: 24px;
`;
const CandidateList = styled.div`
  padding: 8px;
  flex-grow: 1;
  min-height: 100px;
`;

function List({ list, candidates, onOpenModal, onOpenModalInterview, isDropDisabled, search, filter }) {
  // Variables
  let candidateIds = Object.keys(candidates);

  // States
  const [isDragging, setIsDragging] = useState(false);

  return (
    <Container isDragging={isDragging} isDropDisabled={isDropDisabled}>
      <Title>{list.title}</Title>
      <Droppable droppableId={list.id} isDropDisabled={isDropDisabled}>
        {(provided, snapshot) => {
          //setIsDragging(snapshot.isDraggingOver);
          return (
            <CandidateList {...provided.droppableProps} ref={provided.innerRef} isDraggingOver={snapshot.isDraggingOver}>
              {list.candidates
                .filter((id) => {
                  let candidate = candidates[id];
                  if (candidate === undefined) {
                    return false;
                  }
                  return searchObject(search, candidate);
                })
                .filter((id) => {
                  let candidate = candidates[id];
                  if (filter.position != null && candidate.job != filter.position) {
                    return false;
                  }
                  if (filter.location != null && candidate.location != filter.location) {
                    return false;
                  }

                  return true;
                })
                .map((id, index, candidateList) => {
                  let candidate = candidates[id];
                  let currentIndex = candidateIds.indexOf(id);
                  let nextIndex = candidateIds[currentIndex + 1] || null;
                  let previousIndex = candidateIds[currentIndex - 1] || null;
                  candidate["previousCandidate"] = previousIndex;
                  candidate["nextCandidate"] = nextIndex;
                  return <Candidate key={index} index={index} candidate={candidate} previousCandidate={previousIndex} nextCandidate={nextIndex} onOpenModal={onOpenModal} />;
                })}
              {provided.placeholder}
            </CandidateList>
          );
        }}
      </Droppable>
    </Container>
  );
}

export default List;
